import React, { useState } from 'react';
import {
    InfoWrapper,
    TextWrapper,
    TopLine,
    Heading,
    Subtitle,
    BtnWrap,
    ImgWrap,
    Img,
    Card,
    BtnLink,
    FormH4,
    SelectButton,
    ModalButton,
    ModalIcon,
    StatsWrap,
    DetailsWrap,
    AssetImg,
    AssetImgWrap
} from './PlayerDisplayElements';
import PlayerModal from './PlayerModal';
import teamLogos from '../LogoImageForms/TeamLogos';
import asset from '../../images/asset.jpg'

const PlayerCard = ({ player, handleAdd, teamCost }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    var projection;
    // console.log(teamCost)
    if (player.projectedStats) {
        projection = player.projectedStats.FantasyPointsDraftKings
    }
    else {
        if (player.ifDefenseProjectedStats) {
            projection = player.ifDefenseProjectedStats.FantasyPointsDraftKings
        }
        else {
            projection = 0.0
        }
    }

    const logo = teamLogos[player.team];
    return (
        <>
            <Card onClick={handleAdd(player)}>
                <AssetImgWrap>
                    <AssetImg src={asset} alt={player.name} />
                </AssetImgWrap>
                <TextWrapper>
                    <TopLine>{player.name}</TopLine>
                    <DetailsWrap>
                        <ImgWrap>
                            <Img src={logo} alt={player.team} />
                        </ImgWrap>
                        <StatsWrap onClick={(e) => {
                            e.stopPropagation(); // prevent triggering handleAdd
                            openModal();
                        }}>
                            <FormH4>{player.position}</FormH4>
                            <FormH4 errorText={player.currentSalary + teamCost > 50000}>
                                ${player.currentSalary}
                            </FormH4>
                            <FormH4>{projection}</FormH4>
                        </StatsWrap>
                    </DetailsWrap>
                </TextWrapper>
            </Card >
            <PlayerModal isOpen={isModalOpen} onClose={closeModal} player={player} />
        </>
    );
};

export default PlayerCard;
